const styleOverrides = {
    root: {},
};
export const MuiCard = {
    styleOverrides,
};
